import { type FieldValues, type FormState, type Path, type UseFormRegister } from "react-hook-form";

import { CheckboxList, type CheckboxListProps } from "@fronterahealth/frontera-ui-components";

export interface FormCheckBoxListProps<T extends FieldValues> extends Omit<
  CheckboxListProps,
  "name" | "legend" | "ref"
> {
  register: UseFormRegister<T>;
  formState: FormState<T>;
  formKey: Path<T>;
  required?: boolean;
}

export const FormCheckBoxList = <T extends FieldValues>({
  formState,
  formKey,
  register,
  required = false,
  title,
  ...props
}: FormCheckBoxListProps<T>) => {
  const errorMessage = formState.errors[formKey]?.message?.toString() ?? "";
  const registerOutput = register(formKey, {
    required: required ? `${title} is required` : false,
  });
  return (
    <CheckboxList {...props} {...registerOutput} title={title} legend={`${title} choice`} errorMessage={errorMessage} />
  );
};
